<template>
	<el-card>
		<div slot="header">
			<span class="top_title">收支记录</span>
		</div>
		<div class="searchItem">
			<div class="search">
				<span class="searchtips">日期:</span>
				<el-date-picker
					v-model="search.daterange"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
					align="right">
				</el-date-picker>
			</div>
			<div class="search">
				<el-button type="primary" @click="searchData" icon="el-icon-search">查询</el-button>
			</div>
			<div class="search">
				<el-button
					type="primary"
					icon="el-icon-printer"
					@click="print"
					v-if="$common.checkWindowsEnv()"
					>打印</el-button>
				<el-button
					type='primary'
					icon="el-icon-document"
					@click="changePdf"
				>导出</el-button>
			</div>
		</div>
		<el-table :data="tableData" border style="width: 100%" v-loading="loading" show-summary :summary-method="getSummaries">
			<el-table-column label="操作" align='center' width="80px"  v-if="$common.hasLimits('otherCancel')">
				<template slot-scope="{row}">
					<el-button type='text' @click="delone(row.id)">取消</el-button>
				</template>
			</el-table-column>
			<template v-for="(col, index) in cols">
				<el-table-column 
					:key="index"
					:prop="col.prop" 
					:label="col.label" 
					:width="col.width"
					:min-width="col.min_width"
					align="left"
				>
					<template #header v-if="col.column">
						{{col.label}}
						<el-button circle icon="el-icon-top" size="mini" v-if="search.column==col.column&&search.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-if="search.column==col.column&&search.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
					</template>
					<template slot-scope="{ row }">
						<template v-if="col.type=='amountType'">
							<template>
								<div class="tag-group">
									<el-tag v-if="row.type==3" size="mini" key="-" type="danger" effect="dark">
										-{{row.amount}}
									</el-tag>
									<el-tag v-if="row.type==2" size="mini" key="+" type="primary" effect="dark">
										+{{row.amount}}
									</el-tag>
								</div>
							</template>
						</template>
						<template v-else-if="col.type=='pType'">
							<template>
								<template v-if="row.type==2">财务收入</template>
								<template v-else-if="row.type==3">财务支出</template>
							</template>
						</template>
						<template v-else>
							<div>{{row[col.prop]}}</div>
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<el-pagination  style="text-align: right;padding-top:22px"
		:page-sizes="limits" :page-size="limit" 
		layout="total, sizes, prev, pager, next, jumper" 
		:total="maxCount" @size-change="handleSizeChange" 
		@current-change="handleCurrentChange" :pager-count="5"/>
		<ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
	</el-card>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
export default {
	components: {ReportOrder,editShare},
	data() {
		return {
			loading: false,
			pickerOptions: {shortcuts:this.$common.initPickerOptions()},
			search: {
				daterange: [],
				column:'',
				order:'',
			},
			tableData: [],
			maxCount:0,
			sumData: {},
			current: 1,
			limit: 20,
			limits: [20, 50, 120, 250],
			searchObj:{
				page:1,
				limit:20,
			},
			cols:[
				{
					label:'日期',
					prop:'date',
					column:'date'
				},
				{
					label:'金额(元)',
					prop:'',
					column:'amount',
					width:'180',
					type:'amountType'
				},
				{
					label:'款项',
					prop:'',
					width:'180',
					type:'pType'
				},
				{
					label:'备注',
					prop:'remark',
				},
			]
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		print(){
			let array = [];
			let cmp = this.$global.cmpId.cmp;
			array.push(cmp);
			this.$nextTick(()=>{
				this.$refs.roder.extraOpen(8,array);
			})
		},
		changePdf(){
			let array = [1];
			this.$nextTick(()=>{
				this.$refs.share.openList(array,8,this.searchObj);
			})
		},
		handleSizeChange(val) {
			this.limit = val;
			this.searchData();
		},
		handleCurrentChange(val) {
			this.current = val;
			this.searchObj.page = val;
			this.getData();
		},
		searchData(){
			this.current=1;
			this.searchObj = {
				page:this.current,
				limit:this.limit,
			}
			if(this.search.daterange != null&&this.search.daterange.length > 0){
				this.searchObj.start = this.search.daterange[0];
				this.searchObj.end = this.search.daterange[1];
			}
			this.sortTime();
		},
		setSort(column,order){
            if(this.search.column==column&&this.search.order==order){
                this.search.column = '';
                this.search.order = '';
            }else{
                this.search.column = column;
                this.search.order = order;
            }
            this.sortTime();
        },
		sortTime(){
            if(this.search.column){
                this.searchObj.column = this.search.column;
                this.searchObj.order = this.search.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getData();
        },
		getData() {
			this.loading = true
			this.$api.getOtherPayment(this.searchObj).then(res => {
				if(res.data.code==1){
					let dd = res.data.data;
					this.tableData = dd.data;
					this.maxCount = dd.total;
					this.sumData = {
						sumAmount: dd.sumAmount,
					}
				}
				setTimeout(() => {
					this.loading = false
				}, 100)
			}, () => {
				setTimeout(() => {
					this.loading = false
				}, 100)
			})
		},
		getSummaries(param) {
			const {
				columns,
				data
			} = param;
			const sums = [];
			columns.forEach((column, index) => {
				if(index === 0) {
					sums[index] = '全部总计';
					return;
				}
				var sumitem = {
					amount: 'sumAmount',
				}
				var sum = this.sumData[sumitem[column.property]]
				sums[index] = sum == undefined || sum == null ? "" : sum

			});
			return sums
		},
		delone(id){
			this.$api.cancelOtherPayment({ids:id}).then(res=>{
				if(res.data.code==1){
					this.$notify({
						title: "收支记录",
						message: "删除成功",
						type: "success",
						duration: 1000,
					});
					this.getData();
				}
			})
		},
	}
}
</script>